// #region Imports
import { motion } from "framer-motion";
import { Portal } from "../../context/PortalProvider";
import PopUpTile from "./PopUpTile";
// #endregion


function ArchivePopUp({
	activeSection,
	onClose,
	onProjectOpen,
}) {

	if (!activeSection) return null;


	const backgroundClass =
		activeSection.index === 0
			? "workBg"
			: activeSection.index === 1
				? "communityBg"
				: activeSection.index === 2
					? "awardsBg"
					: activeSection.index === 3
						? "mentorshipBg"
						: "projectBg";


	return (
		<Portal>

			<div
				className="
					fixed inset-0 z-[200]
					flex items-center justify-center
					bg-black backdrop-blur-sm p-2
				"
			>

				<motion.div
					className="
						relative bg-ivory rounded-3xl
						h-full w-full py-4 overflow-hidden
						flex flex-col items-start
						justify-between
						small:py-0 small:rounded-xl
					"
					initial={{
						opacity: 0,
						y: 30,
						scale: 0.97,
					}}
					animate={{
						opacity: 1,
						y: 0,
						scale: 1,
					}}
					transition={{
						duration: 0.45,
						ease: [0.22, 1, 0.36, 1],
					}}
				>

					{/* HEADER */}

					<header
						className="
							shrink-0 h-20 px-10
							flex items-center justify-between
							border-b-[1.5px] border-charcoal/40
							small:h-20 small:px-5 w-full
						"
					>

						<aside className="flex gap-4 items-center">

							<img
								src="/icons/darkStar.svg"
								alt="Star"
								loading="lazy"
								className="
									w-8 h-8 animate-spin
									[animation-duration:3s]
								"
							/>

							<h2
								className="
									font-mada text-2xl font-medium
									uppercase tracking-tight
								"
							>
								{activeSection.title}
							</h2>

						</aside>


						<button
							title="Close"
							onClick={onClose}
							className="
								group flex items-center justify-center
								w-9 h-9 rounded-full
								transition-all duration-300
								hover:bg-charcoal
							"
						>

							<img
								className="
									w-4 h-4 transition-all
									duration-300 group-hover:invert
								"
								loading="lazy"
								alt="Close"
								src="/icons/cross.svg"
							/>

						</button>

					</header>


					{/* SCROLLABLE CONTENT */}

					<div
						data-lenis-prevent
						className="
							flex-1 min-h-0 w-full
							overflow-y-auto overflow-x-hidden
							overscroll-contain
							py-12 pt-6 small:py-6
						"
					>

						<div
							className="
								w-full mx-auto px-8
								small:px-6 small:space-y-12
							"
						>

							{activeSection.data.map((item, id) => (
								<PopUpTile
									key={item.id ?? id}
									index={id}
									item={item}
									title={item?.title}
									highlight={item?.highlight}
									skills={item?.skills}
									bg={backgroundClass}
									onOpen={() => onProjectOpen(item)}
								/>
							))}

						</div>

					</div>

				</motion.div>

			</div>

		</Portal>
	);
}


export default ArchivePopUp;